import Logo from "../../assets/images/BX-LOGO.svg";
import {Link} from "react-router-dom";


function WaitingListConfirmation() {
    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">

                                <div className="card-body p-4">

                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                    </div>

                                    <div className="mt-3 text-center">

                                        <h3>You're on the waiting list!</h3>
                                        <p className="text-muted mt-2">
                                            Thanks for joining the BlackX waiting list! BlackX isn't available in
                                            your country just yet, but we'll email you the moment we launch in your
                                            region so you can be one of the first to get started. We've sent a
                                            confirmation to your email. Questions? Reach us at{" "}
                                            <a href="mailto:support@blackx.io" className="text-primary font-weight-medium">
                                                support@blackx.io
                                            </a>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <p className="text-muted">
                                        Go back to
                                        <Link
                                            to="/login"
                                            className="text-primary font-weight-medium ml-1"
                                        >
                                            Log In
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WaitingListConfirmation;